<template>
  <Layout footer>
    <NSpin :show="initLoading" :class="{ 'py-40': initLoading }">
      <div class="app-container app-container_warp rzks_box" style="padding:50px;padding-bottom:0;" v-if="!initLoading">
        <div class="flex items-center py-5 text-base border-b border-gray-300">
          <span class="mr-1" style="font-size:18px;">当前位置：</span>
          <NBreadcrumb>
            <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
            <NBreadcrumbItem>学习中心</NBreadcrumbItem>
            <NBreadcrumbItem>认证考试</NBreadcrumbItem>
          </NBreadcrumb>
        </div>
        <div class="mt-7 p-10  border-gray-300">
          <div style="border-bottom:1px solid #d1d5db;padding-bottom:50px"
            class="flex items-start pb-28 border-b-2 border-dashed border-gray-300">
            <img style="width: 225px" class="flex-shrink-0" :src="imgBaseUrl + userInfo.photo" alt="头像信息" />
            <div class="ml-20 w-3/5" style="margin-top:70px;margin-left:40px;">
              <p class="text-xl" style="font-size:26px">{{ userInfo.stuName }}</p>
              <p class="mt-4 text-gray-500 text-base" style="font-size:16px">
                <span>
                  <img class="jigouico" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/zuzhijigou.png"
                    alt="">
                </span>
                机构：{{ userInfo.tenantName }}
              </p>
              <p class="mt-2 text-gray-500 text-base" style="font-size:16px">
                <span>
                  <img class="jigouico" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/xuexiao_banji.png"
                    alt="">
                </span>
                班级：{{ userInfo.className }}
              </p>
              <p class="mt-2 text-gray-500 text-base" style="font-size:16px">
                <span>
                  <img class="jigouico" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/banzhuren.png"
                    alt="">
                </span>
                班主任：{{ userInfo.headTeacherName }}
              </p>
              <div class="flex justify-between mt-10 w-full text-xl" style="margin-top:60px;width:480px">
                <div class="text-center">
                  <p></p>
                  最高得分
                  <span style="color: #ea4c00;font-size:40px;font-weight: 700;"
                    v-if="info.headScore<60">{{ info.headScore }}</span> 分
                  <span style="color: rgb(0,255,12);font-size:40px;font-weight: 700;"
                    v-if="info.headScore>=60">{{ info.headScore }}</span>
                  <span v-if="info.headScore>=60">
                    分
                  </span>

                  <p class="mt-2 text-base">

                  </p>
                </div>
                <div class="text-center">
                  <p></p>
                  认证考试机会&nbsp;&nbsp;
                  剩
                  <span style="color:#2d60f6;font-size:40px;font-weight:700;">{{ info.examChance }}</span>
                  次
                  <!-- <p class="mt-2 text-base">
                    剩
                    <span style="color: #ea4c00">{{ info.examChance }}</span>
                    次
                  </p> -->
                </div>
                <!-- <div class="text-center">
                  <p></p>
                  考试用时&nbsp;&nbsp;<span
                    style="color:#2d60f6;font-size:40px;font-weight: 700;">{{ info.examTime }}</span>
                  <p class="mt-2 text-base"></p>
                </div> -->
              </div>
            </div>
            <n-button type="primary" v-if="info.examChance === 1000 ? '未参加':''" class="ml-auto">
              {{ info.examChance === 1000 ? '未参加' : info.headScore >= 60 ? '合格' : '不合格' }}
            </n-button>
            <div v-else-if="info.headScore >= 60">
              <img style="width:140px;" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/hege-2.png" alt="">
            </div>
            <div v-else>
              <img style="width:140px;" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/center/buhege-2.png" alt="">

            </div>
          </div>
          <!-- <div class="inline-block mt-4 py-1 text-xl border-b-2 border-dashed border-gray-300">
            认证考试
          </div> -->
          <div class="inline-block text-xl title-line mintitle_text" style="margin-top:50px;">认证考试</div>
          <div style="margin-top:50px;">
            <div class="flex flex_ambo" style="height:290px;position: relative;width:1000px;">
              <div style="padding-left:320px;margin-top:-80px;">
                <img class="erweima_logo_img"
                  src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/erweima/48f33d78199376970b337ea3a4af6d5.png"
                  alt="">
                <div class="erweima_content_text" style="padding-left:18px;">
                  <div>
                    请使用智慧人才APP或者小程序
                  </div>
                  <div>扫描认证考试二维码进行考试</div>
                </div>
              </div>
              <div class="qrcode_o_bg">
                <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhrc/erweima/725d89496dfeba0c6e2a089657bf19c.png"
                  alt="">
              </div>
              <div class="qrcode-img" style="margin-bottom:60px;margin-left:90px;z-index:1;">
                <div class="qrcode text-center">
                  <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/zhihuirencai/type___jumpTest.png" alt="二维码" />
                  <!-- <p>认证考试二维码</p> -->
                </div>
                <div class="qrcode-error" v-if="qrcodeBeoverdue">
                  <!-- <p>{{ qrcodeMsg }}</p> -->
                  <!-- <button class="refresh" @click="refreshQrcode">刷新二维码</button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </NSpin>
  </Layout>
</template>

<script setup>
import { useRouter } from 'vue-router';
import Layout from '@/components/Layout';
import { getUserInfoApi, examIndexInfoApi } from '@/api';
import { reactive, ref } from 'vue';

const router = useRouter();
function gotoHome () {
  router.push('/');
}
const imgBaseUrl = 'https://qingjuck.oss-cn-shanghai.aliyuncs.com/';
const userInfo = reactive({});
const initLoading = ref(true);
getUserInfoApi()
  .then(res => res.data)
  .then(res => {
    const { photo, stuName, tenantName, className, headTeacherName } = res;
    Object.assign(userInfo, {
      photo,
      stuName,
      tenantName,
      className,
      headTeacherName,
    });
  })
  .finally(() => (initLoading.value = false));

const info = reactive({});
examIndexInfoApi().then(res => {
  const { headScore, examChance, examTime, examNum } = res.data;
  Object.assign(info, {
    headScore,
    examChance,
    examTime,
    examNum,
  });
});
</script>

<style lang="scss" scoped>
:deep(.n-breadcrumb-item) {
  font-size: 16px;
}
.jigouico {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-top: -4px;
}
.title-line {
  position: relative;
  text-align: left;
  padding-bottom: 10px;
  &:after {
    position: absolute;
    content: '';
    height: 6px;
    width: 44px;
    background-color: #2d60f6;
    left: 0;
    bottom: -5px;
    transform: translateX(0);
  }
}

.qrcode > img {
  width: 170px;
  height: 176px;
  margin-bottom: 5px;
}
.rzks_box {
  padding: 50px !important;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 8px;
}
.qrcode_o_bg {
  width: 308px;
  height: 287px;
  // background-color: red;
  z-index: 0;
  position: absolute;
  right: -32px;
  opacity: 0.2;
  bottom: 0;
}
</style>
